import { useState, FormEvent } from "react";
import { Link } from "react-router-dom";
import { PublicHeader } from "../components/Header";
import { Button } from "../components/Button";
import { Input } from "../components/Input";
import { ErrorBanner } from "../components/ErrorBanner";
import { SuccessBanner } from "../components/SuccessBanner";
import { forgotPassword } from "../api/auth";

export function ForgotPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      await forgotPassword(email);
      // Anti-enumeration: always success message regardless of email existence
      setSuccess(
        "Если email зарегистрирован в системе, мы отправили инструкции по сбросу пароля. Проверьте почту (и папку «Спам»)."
      );
      setEmail("");
    } catch (err: unknown) {
      const ex = err as { response?: { data?: { detail?: string | unknown } } };
      const msg = ex?.response?.data?.detail;
      // Even on errors that aren't enumeration-related, keep generic
      if (
        typeof msg === "string" &&
        !msg.toLowerCase().includes("email") &&
        !msg.toLowerCase().includes("user") &&
        !msg.toLowerCase().includes("not found")
      ) {
        setError(msg);
      } else {
        // Treat as success for security
        setSuccess(
          "Если email зарегистрирован в системе, мы отправили инструкции по сбросу пароля. Проверьте почту (и папку «Спам»)."
        );
        setEmail("");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1 flex items-center justify-center p-6">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md bg-white p-8 border border-[var(--color-line)]"
        >
          <h1
            className="text-3xl mb-2"
            style={{ fontFamily: "var(--font-serif)" }}
          >
            Восстановление пароля
          </h1>
          <p className="text-[var(--color-muted)] mb-6">
            Введите email — пришлём ссылку для сброса
          </p>

          <ErrorBanner message={error} />
          <SuccessBanner message={success} />

          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="email"
          />

          <Button
            type="submit"
            variant="primary"
            loading={loading}
            className="w-full"
          >
            Отправить инструкции
          </Button>

          <div className="mt-4 text-center text-sm space-x-4">
            <Link to="/login" className="text-[var(--color-accent)]">
              Вспомнили? Войти
            </Link>
            <Link
              to="/reset-by-code"
              className="text-[var(--color-accent)]"
            >
              У меня код от учителя
            </Link>
          </div>

          <p className="mt-6 pt-6 border-t border-[var(--color-line)] text-xs text-[var(--color-muted)] text-center">
            Если у вас нет доступа к email — попросите классного руководителя
            выдать одноразовый код для сброса пароля.
          </p>
        </form>
      </main>
    </div>
  );
}
